import $ from 'jquery';
// https://github.com/thecreation/breakpoints-js
import Breakpoints from 'breakpoints-js';
import scrollTo from 'jquery.scrollto';

const tabs = {
    copyTabHead() {
        $('.js-tab-mobile').each(function () {
            var $tabHeaderItem = $(this).find('.c-tab__head__item').clone();
            $('.js-tab-desktop').append($tabHeaderItem);
        });
    },
    bindMobileEvents() {
        if ((Breakpoints.is('xs') || Breakpoints.is('sm')) && !$('.c-tab__head').hasClass('js-tab-order-history')) {
            $('.c-tab__head__item--active').removeClass('c-tab__head__item--active');
            $('.c-tab__body--active').removeClass('c-tab__body--active');
            if ($('span[data-showReviewTabOnLoad="true"]').length > 0) {
                $('#reviewTabBody').addClass('c-tab__body--active');
                $('div [data-href="reviewTabBody"]').addClass('c-tab__head__item--active');
            } else {
                if ($('span[data-showInfoTabOnLoad="true"]').length > 0) {
                    $('#infoTabBody').addClass('c-tab__body--active');
                    $('div [data-href="infoTabBody"]').addClass('c-tab__head__item--active');
                }
            }
        }
        $('.js-tab-mobile').on('click', function () {
            var $headItem = $(this).find('.c-tab__head__item');
            var bodyId = $headItem.attr('data-href');
            if ($headItem.hasClass('c-tab__head__item--active')) {
                $headItem.removeClass('c-tab__head__item--active');
                $('#' + bodyId).removeClass('c-tab__body--active');
            }
            else {
                $headItem.addClass('c-tab__head__item--active');
                $('#' + bodyId).addClass('c-tab__body--active');
            }
        });

        Breakpoints.on('xs sm', {
            enter: function () {
                if(!$('.c-tab__head').hasClass('js-tab-order-history')) {
                    $('.c-tab__head__item--active').removeClass('c-tab__head__item--active');
                    $('.c-tab__body--active').removeClass('c-tab__body--active');
                    if ($('span[data-showReviewTabOnLoad="true"]').length > 0) {
                        $('#reviewTabBody').addClass('c-tab__body--active');
                        $('div [data-href="reviewTabBody"]').addClass('c-tab__head__item--active');
                    } else {
                        if ($('span[data-showInfoTabOnLoad="true"]').length > 0) {
                            $('#infoTabBody').addClass('c-tab__body--active');
                            $('div [data-href="infoTabBody"]').addClass('c-tab__head__item--active');
                        }
                    }
                }
            },
            leave: function () {
                if(!$('.c-tab__head').hasClass('js-tab-order-history')) {
                    $('.js-tab-desktop .c-tab__head__item--active').removeClass('c-tab__head__item--active');
                    $('.c-tab__body--active').removeClass('c-tab__body--active');
                    $('.c-tab__head__item').first().addClass('c-tab__head__item--active');
                    $('.c-tab__body').first().addClass('c-tab__body--active');
                }
            }
        });
    },
    bindDesktopEvents() {
        $('.js-tab-desktop .c-tab__head__item').on('click', function () {
            var bodyId = $(this).attr('data-href');
            $('.c-tab__head__item--active').removeClass('c-tab__head__item--active');
            $('.c-tab__body--active').removeClass('c-tab__body--active');
            $('div [data-href="' + bodyId + '"]').addClass('c-tab__head__item--active');
            $('#' + bodyId).addClass('c-tab__body--active');
        });
    },
    scollToReviewForm() {
        if ($('span[data-showReviewTabOnLoad="true"]').length > 0) {
            var offset = $('.write-review').offset().top - $('#header-sticky-placeholder').height();
            $('body').scrollTo(offset, 'slow');
        }
    },
    filterOrderHistory() {
        var orderArray = [];
        $('.c-responsive-table.order-history .c-responsive-table__tbody').each(function () {
            var orderNumber = $(this).attr('data-order-number');
            var entries = $('.c-responsive-table.order-history .c-responsive-table__tbody[data-order-number="' + orderNumber + '"]');
            if(entries.length > 1) {
                for (var i = 1; i < entries.length ; i++) {
                    $(entries[i]).addClass('removed');
                }
            }
        });
    },
    bindOrderHistoryTabs() {
        $('.js-tab-order-history .c-tab__head__item').on('click', function () {
            var displayClass = $(this).attr('data-class');
            $('.c-tab__head__item--active').removeClass('c-tab__head__item--active');
            $('div [data-class="' + displayClass + '"]').addClass('c-tab__head__item--active');
            $('.c-responsive-table.order-history .c-responsive-table__tbody').removeClass('show');
            $('.c-responsive-table.order-history .c-responsive-table__tbody.' + displayClass).addClass('show');
        });
    },
};

// DOM ready
$(() => {
    tabs.copyTabHead();
    tabs.bindMobileEvents();
    tabs.bindDesktopEvents();
    tabs.scollToReviewForm();
    tabs.filterOrderHistory();
    tabs.bindOrderHistoryTabs();
});

export default tabs;
